export default () => (
  <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 44H52C53.6569 44 55 45.3431 55 47C55 48.6569 53.6569 50 52 50H5V44Z" fill="#8FB4FF" />
    <path
      d="M27 31.9893C27 30.8686 28.4759 30.4598 29.0525 31.4208C29.4817 32.1361 30.5183 32.1361 30.9475 31.4208L31.5 30.5C32.1794 29.3676 33.8206 29.3676 34.5 30.5C35.1794 31.6324 36.8206 31.6324 37.5 30.5C38.1794 29.3676 39.8206 29.3676 40.5 30.5C41.1794 31.6324 42.8206 31.6324 43.5 30.5C44.1794 29.3676 45.8206 29.3676 46.5 30.5L47.0525 31.4208C47.4817 32.1361 48.5183 32.1361 48.9475 31.4208C49.5241 30.4598 51 30.8686 51 31.9893V42H27V31.9893Z"
      fill="#8FB4FF"
    />
    <path d="M30 33V42" stroke="#7296DE" /> <path d="M36 33V42" stroke="#7296DE" />
    <path d="M42 33V42" stroke="#7296DE" /> <path d="M48 33V42" stroke="#7296DE" />
    <path
      d="M27 28C27 22.4772 31.4772 18 37 18H38.6673C41.7616 18 44.7292 16.7708 46.9173 14.5827L49 12.5L51.5524 15.3259C54.0785 18.1227 54.0785 22.3773 51.5524 25.1741C49.9274 26.9733 47.6164 28 45.1921 28H27Z"
      fill="#CDDBF6"
    />
  </svg>
)
